/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AssetInventoryCompletenessSection = {
    Relatives: 'Relatives',
    Income: 'Income',
    Expenses: 'Expenses',
    OwnClaims: 'OwnClaims',
    Assets: 'Assets',
    PropertyRights: 'PropertyRights',
    Donations: 'Donations'
} as const;
export type AssetInventoryCompletenessSection = typeof AssetInventoryCompletenessSection[keyof typeof AssetInventoryCompletenessSection];


export function instanceOfAssetInventoryCompletenessSection(value: any): boolean {
    for (const key in AssetInventoryCompletenessSection) {
        if (Object.prototype.hasOwnProperty.call(AssetInventoryCompletenessSection, key)) {
            if (AssetInventoryCompletenessSection[key as keyof typeof AssetInventoryCompletenessSection] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AssetInventoryCompletenessSectionFromJSON(json: any): AssetInventoryCompletenessSection {
    return AssetInventoryCompletenessSectionFromJSONTyped(json, false);
}

export function AssetInventoryCompletenessSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetInventoryCompletenessSection {
    return json as AssetInventoryCompletenessSection;
}

export function AssetInventoryCompletenessSectionToJSON(value?: AssetInventoryCompletenessSection | null): any {
    return value as any;
}

export function AssetInventoryCompletenessSectionToJSONTyped(value: any, ignoreDiscriminator: boolean): AssetInventoryCompletenessSection {
    return value as AssetInventoryCompletenessSection;
}

